export default class Product {
  // eslint-disable-next-line
  init() {
    const $product = $("body.single-product");

    if (!$product.length) {
      return;
    }

    (async () => {
      await import("slick-carousel");
      await import("lightgallery");
      await import("lg-thumbnail");
      await import("lg-zoom");

      const $gallery = $(".product-photos");

      $gallery.lightGallery({
        selector: "a",
        thumbnail: true,
        toogleThumb: false,
        download: false,
        subHtmlSelectorRelative: true,
        autoplayFirstVideo: true,
      });

      $(".product-thumbnails").slick({
        vertical: false,
        infinite: false,
        swipe: false,
        slidesToShow: 4,
        arrows: true,
        variableWidth: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"><span class="svg-container"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6"><path fill="currentColor" d="M.225 5.39a.73.73 0 01.23-.53L5.169.36a.812.812 0 011.111 0l4.714 4.5a.725.725 0 010 1.06.812.812 0 01-1.11 0l-4.16-3.97-4.158 3.97a.812.812 0 01-1.111 0 .73.73 0 01-.23-.53z" /></svg></span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="svg-container"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7"><path fill="currentColor" d="M11.775 1.61a.73.73 0 01-.23.53l-4.714 4.5a.812.812 0 01-1.111 0l-4.714-4.5a.725.725 0 010-1.06.812.812 0 011.11 0l4.16 3.97 4.158-3.97a.812.812 0 011.111 0 .73.73 0 01.23.53z"/></svg></span></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              prevArrow: '<button type="button" class="slick-prev"><span class="svg-container"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22"><path fill="currentColor" d="M10.495 21.488c-.383 0-.767-.146-1.06-.439L.447 12.06a1.497 1.497 0 010-2.118l8.99-8.99a1.497 1.497 0 012.118 0 1.497 1.497 0 010 2.119L3.624 11l7.93 7.93a1.497 1.497 0 01-1.059 2.558z" /></svg></span></button>',
              nextArrow: '<button type="button" class="slick-next"><span class="svg-container"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22"><path fill="currentColor" d="M1.505.512c.383 0 .767.146 1.06.439l8.989 8.99a1.497 1.497 0 010 2.118l-8.99 8.99a1.497 1.497 0 01-2.118 0 1.497 1.497 0 010-2.119L8.376 11 .446 3.07A1.497 1.497 0 011.505.511z"/></svg></span></button>',
            },
          },
        ],
      });

      $gallery.slick({
        infinite: false,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        swipe: false,
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="37" viewBox="0 0 19 37"><path fill="currentColor" d="M18.137 0c.222 0 .44.085.61.258a.89.89 0 010 1.243l-16.663 17 16.663 16.997a.89.89 0 010 1.242.847.847 0 01-1.22 0L.253 19.12a.89.89 0 010-1.242L17.527.258a.848.848 0 01.61-.258z"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="37" viewBox="0 0 19 37"><path fill="currentColor" d="M.863 37a.848.848 0 01-.61-.258.89.89 0 010-1.243l16.663-17L.253 1.502a.89.89 0 010-1.242.847.847 0 011.22 0l17.274 17.62a.89.89 0 010 1.242L1.473 36.742a.848.848 0 01-.61.258z"/></svg></button>',
        adaptiveHeight: true,
      });

      $(".product-thumbnails .slick-slide:first-child .woocommerce-product-gallery__image").addClass("active");

      $(document.body).on("click", ".product-thumbnails .slick-slide", (e) => {
        e.preventDefault();
        const $el = $(e.currentTarget);
        $gallery.slick("slickGoTo", $el.data("slick-index"));
        $(".product-thumbnails .slick-slide .woocommerce-product-gallery__image").removeClass("active").attr("disabled", true);
        $el.find(".woocommerce-product-gallery__image").addClass("active");

        setTimeout(() => {
          $(".product-thumbnails .slick-slide").attr("disabled", false);
        }, 500);
      });
    })();
  }
}
